import { render, staticRenderFns } from "./CurrentShiftDetails.vue?vue&type=template&id=93e1c344&"
import script from "./CurrentShiftDetails.vue?vue&type=script&lang=js&"
export * from "./CurrentShiftDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports